import { collection, deleteDoc, doc, getDocs, setDoc } from 'firebase/firestore'
import { firestore, iamAuth } from '@/lib/firebase'
import { ScheduledTransactionSchema, type ScheduledTransaction } from './types'

function requireUid(): string {
  const uid = iamAuth.currentUser?.uid
  if (!uid) throw new Error('Not signed in')
  return uid
}

function schedulesCollection(uid: string) {
  return collection(firestore, 'users', uid, 'scheduledTransactions')
}

export async function fetchSchedules(): Promise<ScheduledTransaction[]> {
  const uid = requireUid()
  const snap = await getDocs(schedulesCollection(uid))
  const out: ScheduledTransaction[] = []
  for (const d of snap.docs) {
    const parsed = ScheduledTransactionSchema.safeParse(d.data())
    if (parsed.success) out.push(parsed.data)
    else console.warn('scheduled txn doc failed parse, skipping:', d.id, parsed.error)
  }
  return out.sort((a, b) => a.nextOccurrence.localeCompare(b.nextOccurrence))
}

export async function saveSchedule(s: ScheduledTransaction): Promise<void> {
  const uid = requireUid()
  await setDoc(doc(schedulesCollection(uid), s.id), s)
}

export async function deleteSchedule(id: string): Promise<void> {
  const uid = requireUid()
  await deleteDoc(doc(schedulesCollection(uid), id))
}
